import { Button } from "@buildpy/ui/button";

import { Link } from "@/lib/nav";
import { useNativeApp } from "@/lib/use-native-app";
import { START_PICK_HREF } from "@/pages/start/start-target";

// 앱 첫 화면의 고르는 화면(/start?pick=1)으로 — 안내 카드의 버튼 자리. 앱 안에서만 쓰도록 부르는 쪽이 가린다.
export const AppStartButton = () => (
  <Button asChild size="sm" variant="outline">
    <Link data-testid="app-start-link" href={START_PICK_HREF}>
      처음 화면으로
    </Link>
  </Button>
);

// 살아 있는 고객 화면 맨 아래 작은 진입 — 앱 안에서만 보인다(주소창이 없어 다른 공사·직원 로그인으로 갈 길).
export const AppStartFootLink = () =>
  useNativeApp() ? (
    <p className="print-hide mt-8 px-4 text-center text-xs text-muted-foreground">
      <Link className="tap-target relative underline-offset-2 hover:underline" data-testid="app-start-foot-link" href={START_PICK_HREF}>
        다른 공사 연결 · 직원 로그인
      </Link>
    </p>
  ) : null;
